import { useState, useEffect } from "react";
import LogoImage from "../../../assets/images/logo.png";
import { Button } from "droplr-react-ui-v2";
import "./who-is-using-step.scss";
import { ONBOARDING_STEP } from "../../../constants/app.constants";
import {
  ImageCheckboxComponent,
  ImageCheckboxItem,
} from "../../ui-components/image-checkbox/image-checkbox.component";
import MyTeamCheckboxImage from "../../../assets/images/steps/my-team-checkbox.svg";
import JustMeCheckboxImage from "../../../assets/images/steps/just-me-checkbox.svg";

export interface WhoIsUsingStepProps {
  SetCurrentStep: Function;
  OnComplete: Function;
}

export const WhoIsUsingStepComponent = ({
  SetCurrentStep,
  OnComplete,
}: WhoIsUsingStepProps): JSX.Element => {
  const CheckboxItems: ImageCheckboxItem[] = [
    {
      Image: JustMeCheckboxImage,
      Label: "Just me",
      Value: "PERSONAL",
      OnClick: () => {},
    },
    {
      Image: MyTeamCheckboxImage,
      Label: "My Team",
      Value: "TEAM",
      OnClick: () => {},
    },
  ];
  const [SelectedItem, SetSelectedItem] = useState(CheckboxItems[0].Value);

  return (
    <>
      <div className="who-is-using-step step-component-container fade-in">
        <div className="logo-image">
          <img src={LogoImage} alt="Droplr Logo" />
        </div>
        <div className="who-is-using-step-title">Who will be using Droplr?</div>
        <div className="who-is-using-checkbox">
          <ImageCheckboxComponent
            Items={CheckboxItems}
            Size={"large"}
            Multiselect={false}
            OnSelect={(option: any) => {
              SetSelectedItem(option);
            }}
          />
        </div>
        <div className="who-is-using-step-buttons">
          {/* <Button
            label="Back"
            onClick={() => SetCurrentStep(ONBOARDING_STEP.WELCOME)}
            variant="secondary"
            
            
          /> */}
          <Button
            label="Continue"
            
            onClick={() => {
              OnComplete(SelectedItem);
              /**
               * Skip the team onboarding step if the user is using Droplr for personal use
               */
              if (SelectedItem === "PERSONAL") {
                SetCurrentStep(ONBOARDING_STEP.USAGE);
              } else {
                SetCurrentStep(ONBOARDING_STEP.TEAM_INTRO)
              }
            }}
            variant="primary"
            
          />
        </div>
      </div>
    </>
  );
};
